// extracted by mini-css-extract-plugin
module.exports = {"root":"SourceManage_root_2Tsrj","nameInput":"SourceManage_name-input_3Pgp4","hr":"SourceManage_hr_2CKIC","operations":"SourceManage_operations_LZY_7"};